import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { GenericValidator } from '../../validation/general-validation';
import { Router } from '@angular/router';
import { AuthService } from '../../service/auth.service';
import { UserModel } from '../../model/IUser';
import { CompanyService } from 'src/app/service/company.service';
import { ConfigurationsService } from 'src/app/Service/configurations.service';

@Component({
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  user: UserModel = new UserModel();
  errorMsg: string;

  // Use with the generic validation message class
  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;
  loginForm: FormGroup;
  logopath: string = '';
  url: string = '';
  CompanyCode: string;

  constructor(
    private userService: AuthService,
    private companyservice: CompanyService,
    private configService: ConfigurationsService,
    private router: Router,
    private form: FormBuilder
  ) {
    this.userService.getValidationMessage().subscribe((resp) => {
      this.validationMessages = resp.LoginForm;
      this.genericValidator = new GenericValidator(this.validationMessages);
    });

    this.CompanyCode = localStorage.getItem('CompanyCode');
    this.GetCompanyCodeFromJson('Y');
  }

  ngOnInit(): void {
    this.loginForm = this.form.group({
      UserName: ['', [Validators.required]],
      Password: ['', [Validators.required]],
    });
  }

  GetCompanyCodeFromJson(forLogo) {
    if (this.CompanyCode == null) {
      const response = this.configService.getAppConfig();
      if (response != null) {
        if (response['GetCompanyCodeFromURL'] == 'Y') {
          this.url = this.router['location']._platformLocation.location.href;
          this.url = this.url.replace('http://', '');
          this.url = this.url.replace('https://', '');
          var array = this.url.split('.');
          this.CompanyCode = array[0];
        } else {
          this.CompanyCode = response['CompanyCode'];
        }
        localStorage.setItem('CompanyCode', this.CompanyCode);
      }
    }
    // if (forLogo == 'Y') {
    //   setTimeout(() => {
    //     this.GetCompanyDetails(this.CompanyCode);
    //   }, 2000);
    // }
  }

  //Raise validation on blur
  blur(): void {
    if (this.genericValidator) {
      this.displayMessage = this.genericValidator.processMessages(
        this.loginForm
      );
    }
  }

  //Call on click login
  login(): void {
    if (this.loginForm.invalid) {
      this.loginForm.updateValueAndValidity();
      this.displayMessage = this.genericValidator.processMessages(
        this.loginForm,
        true
      );
      return;
    }

    var login = { ...this.user, ...this.loginForm.value };

    if (this.CompanyCode == null) {
      this.GetCompanyCodeFromJson('N');
    }

    this.userService
      .authentication(login.UserName, login.Password, this.CompanyCode)
      .subscribe(
        (result) => {
          if (result) {
            localStorage.setItem('IsBackFromGraph', 'N');
            localStorage.setItem('IsFromAddCompany', 'N');
            if (this.CompanyCode.toLowerCase() == 'chen') {
              this.router.navigate(['/admin/userwisedashboard']);
            } else if (this.CompanyCode.toLowerCase() == 'fgglass') {
              this.router.navigate(['/common/graphs']);
            } else {
              this.router.navigate(['/admin/debtronics-dashboard']);
            }
          }
        },
        (error) => {
          this.errorMsg = error;
        }
      );
  }

  // get Company Details
  // GetCompanyDetails(CompanyCode) {
  //   this.companyservice.GetCompanyDetailsByCompanyCode(CompanyCode).subscribe(
  //     (result) => {
  //       if (result) {
  //         if (result.LogoPath != null) {
  //           this.logopath = this.configService.serviceUrl('ServiceURL') + result.LogoPath;
  //           localStorage.setItem('CompanyName', result.CompanyName);
  //         }
  //       }
  //     }
  //   )
  // }
}
